import { createPatchEndpoint } from '@sonar-software/sonar-http';
import { UserSalesforcePreferences } from '@types';

export type PatchUserSalesforcePreferencesRequest = Partial<UserSalesforcePreferences> & {
	userId: number;
};

export const patchUserSalesforcePreferences = createPatchEndpoint<PatchUserSalesforcePreferencesRequest>(
	(request) => `/api/v2/user/${request.userId}/salesforce-preferences`,
	{
		requestTransform: ({ userId, ...rest }) => ({ ...rest })
	}
);
